<template>
  <div class="menu-panel">
    <table class="table title-panel">
      <thead>
        <tr>
          <th>菜单名称</th>
          <th width="50px">操作</th>
        </tr>
      </thead>
    </table>
      <div class="roleform menu-form">
        <el-form size="small" class="prepend-equal">
          <el-form-item>
            <div class="flex-row" style="width: 100%;">
              <!--<el-tree-->
                <!--style="width: 100%"-->
                <!--:data="tempMenu"-->
                <!--node-key="id"-->
                <!--show-checkbox-->
                <!--:props="defaultProps"-->
                <!--ref="tree"-->
                <!--@check-change="handleCheckChange"-->
                <!--:expand-on-click-node="false"-->
                <!--:render-content="renderContent"-->
              <!--&gt;-->
              <!--</el-tree>-->
              <el-tree
                class="menu-tree"
                style="width: 100%;"
                :data="tempMenu"
                node-key="id"
                :props="defaultProps"
                ref="tree"
                :expand-on-click-node="false"
                :render-content="renderContent"
              >
              </el-tree>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="text-center form-btn">
        <!-- <button v-if="isShowBtn('update')" type="button" class="btn btn-sm btn-primary btn-save" :loading="submitLoading" @click="submitForm">保存</button> -->
        <el-button v-if="isShowBtn('update')" class="primary-btn-g bottom-btn" icon="CircleCheck" :loading="submitLoading" @click="submitForm">保存</el-button>
        <el-button v-if="isShowBtn('update')" class="warning-btn-g bottom-btn" icon="CircleClose" @click="resetForm">重置</el-button>
        <!-- <button v-if="isShowBtn('update')" type="button" class="btn btn-sm btn-white btn-cancle" @click="resetForm">重置</button> -->
      </div>
    <Modal modalTitle="编辑" modalId="edit-modal" class="edit-form">
      <el-form ref="form" :model="form" :rules="rules" class="prepend-equal" size="small">
        <el-form-item prop="name" class="required">
           <div class="flex-row">
            <span class="el-input-group__prepend select-prepend">菜单名称</span>
            <el-input placeholder="" v-model.trim="form.name" clearable style="flex:1;">
            <!-- <template slot="prepend">菜单名称</template> -->
            </el-input>
           </div>
        </el-form-item>
        <el-form-item >
          <div class="flex-row">
            <span class="el-input-group__prepend select-prepend">菜单层级</span>
            <el-select v-model="form.menuLevel" placeholder="请选择菜单层级" style="flex:1;">
              <el-option
                v-for="item in levelOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item >
          <div class="flex-row">
            <span class="el-input-group__prepend select-prepend">上级菜单</span>
            <el-select v-model="form.pid" placeholder="请选择上级菜单" style="flex:1;" :disabled="menuDisabled">
              <el-option
                v-for="item in menuOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="flex-row">
            <span class="el-input-group__prepend select-prepend">是否启用</span>
            <el-radio-group v-model="form.used" @change="handleItemChange" :disabled="usedDisabled">
              <el-radio  :label=true>是</el-radio>
              <el-radio  :label=false>否</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
      </el-form>
      <div class="text-center m-t-lg">
        <el-button class="primary-btn-g bottom-btn" icon="CircleCheck" @click.prevent="submitRemark">保存</el-button>
        <el-button class="warning-btn-g bottom-btn" icon="CircleClose" data-dismiss="modal">取消</el-button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import {mapActions} from 'vuex'

  export default {
    name: 'roleForm',
    data() {
      return {
        perms: [],

        role: null,
        form: {
          name: '',
          parentMenu:'',
          pid:1,
          menuLevel:1,
          menuParent:'',
          used:true
        },
        permissions: [],
        indeterminate: [],
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        rules: {
          name: [
            {
              required: true,
              message: '请输入菜单名称',
              trigger: 'blur'
            }
          ]
        },
        submitLoading: false,
        menu:[],
        tempMenu:[],
        menuIds:[],
        itemName:'',
        tempData:{},
        tempNode:{},
        initStatus:false,
        dicPopoverShow: false,
        isWithPopover:false,
        levelOptions:[],
        menuOptionsInit:[
          {
            value: 1,
            label:'一级'
          },
          {
            value: 2,
            label:'二级'
          },
          {
            value: 3,
            label:'三级'
          }
        ],
        menuOptions:[{
          value: 1,
          label:'无'
        }],
        menuDisabled:false,
        usedDisabled:false,
        usedDisabledData:[22,715]
      }
    },
    created() {
      this.perms = 'perms' in localStorage && localStorage.perms !== '' ? JSON.parse(localStorage.perms) : []
    },
    mounted() {
      this._getPermissions()
      // this._coverForm()
      let maxHeight = $('body').height() - $('.menu-panel').offset().top - $('.form-btn').height() - 60
      $('.menu-form').css('max-height', maxHeight + 'px')
    },
    watch:{
      'form.menuLevel'(to){
        if(to === 1){
          this.menuDisabled = true
          this.form.pid = 1
        }else{
          this.menuDisabled = false
          this.getParentMenu(to)
        }
      },
    },
    methods: {
      ...mapActions([
        'fetchData',
        'alertToggle'
      ]),
    // 是否显示这个按钮
    isShowBtn(perm) {
      let url = window.location.pathname.substr(5)
      let len = this.perms.length
      let pid = ''
      for (let i = 0; i < len; i++) {
        if (this.perms[i].url == url) {
          pid = this.perms[i].id
        }
      }
      for (let i = 0; i < len; i++) {
        if (this.perms[i].pid == pid && this.perms[i].perm == perm) {
          return true
        }
      }

      return false
    },
      _getPermissions() {
        this.menu = ('menu' in localStorage && localStorage.menu !== '') ? JSON.parse(localStorage.menu) : [];
        this.tempMenu = this.menu
        this.getTempMenu(this.tempMenu)
        // this._coverForm()
      },
      //只取三级菜单
      getTempMenu(menu = []){
        menu.map(item=>{
          if(item.children && item.children.length){
            let status = true
            item.children.map(itemChild =>{
              status = itemChild.id ? true : false
            })
            if(status){
              this.getTempMenu(item.children)
            }else{
              item.children = []
            }
          }
        })
      },
      // handleCheckChange(data, checked, childNodeChecked) {
      //   data.used = checked
      //   if(data.children && data.children.length){
      //     data.children.map((item, index) =>{
      //       item.used = checked
      //       if(item.children && item.children.length){
      //         item.children.map((cItem, cIndex) =>{
      //           cItem.used = checked
      //         })
      //       }
      //     })
      //   }
      //   let menu = this.tempMenu
      //   this._coverForm()
      // },
      //保存
      submitForm(){
        let url = 'ROLE.UPDATE_MENU'
        let params = {
          params: JSON.stringify(this.tempMenu)
        }
        this.fetchData({
          url,
          method: 'post',
          params
        }).then(res => {
          this.alertToggle({
            alertType: 'success',
            alertContent: '更新菜单成功，请重新登录后更新菜单！'
          })
          // this.updateForm()
        }).catch(err => {
        })
      },
      //重新获取菜单数据
      // updateForm(){
      //   let url = 'ROLE.GET_MENU'
      //   this.fetchData({
      //     url,
      //     method: 'get',
      //     params
      //   }).then(res => {
      //     localStorage.menu = JSON.stringify(res.data)
      //     this._getPermissions()
      //   }).catch(err => {
      //   })
      // },
      resetForm() {
        this._getPermissions()
      },
      //勾选数据渲染
      // _coverForm() {
      //   // debugger
      //   this.menuIds = []
      //   this.tempMenu.forEach(item => {
      //     if(!item.children || !item.children.length) {
      //       item.used && this.menuIds.push(item.id)
      //     }else{
      //       item.children.map(itemChild =>{
      //         if(!itemChild.children || !itemChild.children.length){
      //           itemChild.used && this.menuIds.push(itemChild.id)
      //         }else{
      //           itemChild.children.map(child =>{
      //             if(!child.children || !child.children.length){
      //               child.used && this.menuIds.push(child.id)
      //             }
      //           })
      //         }
      //       })
      //     }
      //   })
      //   if(!this.menuIds.length){
      //     this.menuIds.push(22)
      //   }
      //   this.$refs.tree.setCheckedKeys(this.menuIds,true)
      // },

      renderContent(h, { node, data, store }) {
        let showUp = this.isShowBtn('up')
        let showUpdate = this.isShowBtn('update')

        if (showUp && showUpdate) {
          return (
            <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
              <span><span class={data.used ? "text-gray" : "set-ash"}>{node.label}</span></span>
              <span>
                <el-tooltip content="上移" placement="bottom">
                  <el-button style={data.order > 1 ? "font-size: 12px;" : "display: none"} type="text" onClick={ () => this.handleItemMoveUp(node, data) }><i  class="fa fa-arrow-up menu-fa"></i></el-button>
                </el-tooltip>
                <el-tooltip content="编辑" placement="bottom">
                  <el-button style="font-size: 12px;" type="text" onClick={ () => this.handleItemEdit(node, data) }><i class="fa fa-pencil menu-fa"></i></el-button>
                </el-tooltip>
              </span>
            </span>
          )
        }
        if (showUp && !showUpdate) {
          return (
            <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
              <span><span class={data.used ? "text-gray" : "set-ash"}>{node.label}</span></span>
              <span>
                <el-tooltip content="上移" placement="bottom">
                  <el-button style={data.order > 1 ? "font-size: 12px;" : "display: none"} type="text" onClick={ () => this.handleItemMoveUp(node, data) }><i  class="fa fa-arrow-up menu-fa"></i></el-button>
                </el-tooltip>
              </span>
            </span>
          )
        }
        if (!showUp && showUpdate) {
          return (
            <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
              <span><span class={data.used ? "text-gray" : "set-ash"}>{node.label}</span></span>
              <span>
                <el-tooltip content="编辑" placement="bottom">
                  <el-button style="font-size: 12px;" type="text" onClick={ () => this.handleItemEdit(node, data) }><i class="fa fa-pencil menu-fa"></i></el-button>
                </el-tooltip>
              </span>
            </span>
          )
        }
        return (
          <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
            <span><span class={data.used ? "text-gray" : "set-ash"}>{node.label}</span></span>
          </span>
        )
      },
      //编辑
      handleItemEdit(node, data) {
        this.tempNode = node
        this.tempData = data
        this.form.name = data.name
        this.form.menuLevel = data.menuLevel
        this.form.pid = data.pid
        this.form.used = data.used
        this.isWithPopover = true
        //个人工作台,菜单管理不能关闭启用
        this.usedDisabledData = []
          this.usedDisabledData = this.getUnDisabledID(this.tempMenu, [22,715])
        if(this.usedDisabledData.indexOf(data.id) > -1){
          this.usedDisabled = true
        }else{
          this.usedDisabled = false
        }
        this.getMenuLevelOptions(data)
        $("#edit-modal").modal("show");
      },
      //获取上级菜单列表
      getParentMenu(level){
        this.menuOptions = []
        if(level === 1){
          this.form.pid = 1
        }else{
          this.tempMenu.map((item, index) =>{
            if(item.menuLevel === level - 1 && item.id !== this.tempData.id && !item.path){
              this.menuOptions.push({
                value:item.id,
                label:item.name
              })
            }
            if(item.children && item.children.length){
              item.children.map((childItem, childIndex) =>{
                if(childItem.menuLevel === level - 1 && childItem.id !== this.tempData.id && !childItem.path){
                  this.menuOptions.push({
                    value:childItem.id,
                    label:childItem.name
                  })
                }
              })
            }
          })
        }
      },
      //节点上移
      handleItemMoveUp(node, data){
        let newItem = this.changeItem(data)
        this.removeItem(node, data)
        this.appendChildItem(node, data, newItem)
        this.updateTempMenu()
        // this._coverForm()
      },
      changeItem(item){
        let newItem = {
          children: item.children,
          component: item.component,
          desc: item.desc,
          icon: item.icon,
          id: item.id,
          menuLevel:item.menuLevel,
          meta:item.meta,
          name:item.name,
          order:item.order,
          path:item.path,
          perm:item.perm,
          pid:item.pid,
          url:item.url,
          used:item.used
        }
        return newItem
      },
      changeMenuItem(dataArr,itemIndex){
        let arr = []
        dataArr.forEach((item, index)=>{
          arr.push({
            children: item.children,
            component: item.component,
            desc: item.desc,
            icon: item.icon,
            id: item.id,
            menuLevel:item.menuLevel,
            meta:item.meta,
            name:item.name,
            order:item.order,
            path:item.path,
            perm:item.perm,
            pid:item.pid,
            url:item.url,
            used:item.used
          })
        })
        arr[itemIndex] = arr.splice(itemIndex-1, 1, arr[itemIndex])[0]
        return arr
      },
      submitRemark(){
        this.$refs.form.validate((valid) => {
          if (valid) {
            let newItem = this.changeItem(this.tempData)
            newItem.pid = this.form.menuLevel === 1 ? 1 : this.form.pid
            newItem.menuLevel = this.form.menuLevel || this.tempData.menuLevel
            newItem.name = this.form.name || this.tempData.name
            newItem.used = this.form.used
            if(newItem.menuLevel !== this.tempData.menuLevel && this.form.pid === this.tempData.pid){
              this.alertToggle({
                alertType: 'danger',
                alertContent: '请重新选择上级菜单'
              })
              return
            }
            if(newItem.menuLevel === this.tempData.menuLevel && newItem.pid === this.tempData.pid){ //只修改名称和是否禁用
              this.changeMenu(newItem, this.tempMenu)
            }else{
              this.removeItem(this.tempNode, this.tempData)
              this.appendItem(this.tempMenu, newItem)
            }
            this.updateTempMenu()
            this.updateMenuUsed(this.tempMenu)
            $("#edit-modal").modal("hide");
            this.isWithPopover = false
            this.usedDisabledData = [22,715]
          }else{
            return false
          }
        })

        // this._coverForm()
      },
      //上级菜单选择事件
      handleNodeClick(value, node){
        this.form.parentMenu = value.name || ''
        this.form.pid = value.id || 1
        this.form.menuLevel = value.menuLevel + 1 || 1
        this.dicPopoverShow = false
      },
      //新增节点
      appendItem(menu = [], data) {
        if(data.pid === 1){
          this.tempMenu.push(data)
        }else{
          menu.map((item) =>{
            if(data.pid ===  item.id){
              if(!item.children){item.children = []}
              item.children.push(data)
            }else{
              if(item.children && item.children.length){
                this.appendItem(item.children, data)
              }
            }
          })
        }
      },
      //删除节点
      removeItem(node, data) {
        const parent = node.parent;
        const children = parent.data.children || parent.data;
        const index = children.findIndex(d => d.id === data.id);
        children.splice(index, 1);
      },
      //同级菜单增加节点
      appendChildItem(node, data, newItem){
        const parent = node.parent;
        const children = parent.data.children || parent.data;
        children.splice(newItem.order-2, 0, newItem)
      },
      //更新菜单
      updateTempMenu(){
        this.tempMenu.map((item, index) =>{
          item.pid = 1
          item.menuLevel = 1
          item.order = index +1
          if(item.children && item.children.length){
            item.children.map((childItem, childIndex) =>{
              childItem.pid = item.id
              childItem.menuLevel = 2
              childItem.order = childIndex + 1
              if(childItem.children && childItem.children.length){
                childItem.children.map((child, cIndex) =>{
                  child.pid = childItem.id
                  child.menuLevel = 3
                  child.order = cIndex + 1
                })
              }
            })
          }
        })
      },
      //更新菜单是否可见状态
      updateMenuUsed(menu = []){
        menu.map(item =>{
          if(item.children && item.children.length){
            item.children.map(child =>{
              if(child.children && child.children.length){
                this.updatemenuItemUsed(child)
              }
            })
            this.updatemenuItemUsed(item)
          }
        })
      },
      updatemenuItemUsed(item={}){
        let usedStatus = false
        if(item.children && item.children.length){
          item.children.map(child =>{
            if(child.used){usedStatus = true}
          })
          item.used = usedStatus
        }
      },
      //只更改名称和启用
      changeMenu(data, menu = []){
        menu.map(item =>{
          if(item.id === data.id){
            item.name = data.name
            item.used = data.used
            if(item.children && item.children.length){
              if(!data.used){
                this.handledataUsed(item.children)
              }else{
                this.handleAllUsed(item.children)
              }
            }
          }else{
            if(item.children && item.children.length){
              this.changeMenu(data, item.children)
            }
          }
        })
      },
      handledataUsed(data){
        data.map(item =>{
          //个人工作台，菜单管理不能关闭启用
          if(this.usedDisabledData.indexOf(item.id) === -1){
            item.used = false
          }
          if(item.children && item.children.length){
            this.handledataUsed(item.children)
          }
        })
      },
      //上级菜单启用，子菜单启用
      handleAllUsed(data){
        data.map(item =>{
          item.used = true
          if(item.children && item.children.length){
            this.handleAllUsed(item.children)
          }
        })
      },
      //是否禁用
      handleItemChange(val){
        this.form.used = val
      },
      //获取不可禁用的菜单的父节点
      getUnDisabledID(menu = [], unUsed, pid = []){
        menu.map(item =>{
          if(item.menuLevel === 1){pid = [item.id]}
          if(unUsed.indexOf(item.id) > -1 && unUsed.indexOf(item.pid) === -1 && item.pid !== 1){
            pid.map(item =>{
              unUsed.indexOf(item) === -1 && unUsed.push(item)
            })
          }else{
            if(item.children && item.children.length){
                if(pid.length>1){
                  pid.splice(1,1,item.id)
                }else{
                  pid.push(item.id)
                }
              this.getUnDisabledID(item.children, unUsed, pid)
            }
          }
        })
        return unUsed
      },
      //判断菜单的可更换菜单层级
      getMenuLevelOptions(data){
        let levelCount = this.getMenuChildLevelCount(data)
        switch(levelCount){
          case 1:
            this.levelOptions = this.menuOptionsInit
            break;
          case 2:
            this.levelOptions = this.menuOptionsInit.slice(0,2)
            break;
          case 3:
            this.levelOptions = this.menuOptionsInit.slice(0,1)
            break;
        }
      },
      //获取菜单节点深度
      getMenuChildLevelCount(item = {}, count = 1){
        let status = false
        if(item.children && item.children.length){
          item.children.map(itemChild =>{
            if(itemChild.id){status = true }
            if(itemChild.children && itemChild.children.length){
              count = this.getMenuChildLevelCount(itemChild, 1)
            }
          })
          if(status){
            count++
          }
        }
        return count
      }
    },
  }
</script>
<style lang="less" scoped>
  .menu-panel {
    background-color: #fff;
    .title-panel{
      color:@font-darkblue-color-default;
    }
  }
  .menu-tree {
    /deep/ .el-tree-node {
      .el-tree-node__content {
        margin: 2px 0px;
        &:hover {
          background-color: rgba(0, 192, 192, 0.1);
          border: 1px solid rgba(0, 192, 192, 0.3);
          border-radius: 4px;
          .fa {
            color: rgb(0, 192, 192);
            font-size: 16px;
          }
        }
        .fa {
          margin: 0px 5px;
        }
      }
    }
  }
  .bottom-btn {
    margin: 0px 10px;
  }
</style>
<style lang="less">
  .menu-panel {
    height:100%;
    background-color: #fff;
    padding:10px;
    .title-panel{
      width: 50%;
      margin: 0 auto;
    }
    .menu-fa {
      color: #666;
    }
    .menu-fa:hover{
      color: #24caa4;
    }
    ::-webkit-scrollbar {
      width: 6px;
      background-color: @base-color;
      border-radius: 9px;
      height: 10px;
      color: @scrollbar-color-normal;
    }
    .set-ash {
      color: #ccc;
    }
  }
  .menu-form {
    overflow: scroll;
  }
  .el-autocomplete{
    width: 100%;
  }
  .autocompleteClass {
    top: 208px!important;
    left: 50%!important;
    transform: translate(-50%);
    margin-left: -170px;

  }
  .PCA-tree {
    max-width: 300px;
    max-height: 280px;
    overflow: auto;
  }
  .edit-form{
    .el-popper{
      margin-top: 220px;
      margin-left: 37%;
    }
    .select-prepend{
      width: 100px !important;
    }
  }
  .tree-modal{
    max-width: 400px;
    max-height: 380px;
    overflow: auto;
  }
  .edit-modal{
    .btn-save{
      background-color:#24caa4;
      border:1px solid #03bc92;
      color:#fff;
    }
    .btn-cancle{
      color:#666;
      border:1px solid #ddd;
    }
    .btn-save,.btn-cancle{
      width:80px;
      height:30px;
      font-size:14px;
      line-height:14px;
      margin: 0 10px;
    }
  }
</style>
